<template>

  <div class="search">

    <input-keyword 
      class="inputKeyword"
      v-model="keywords"
      style="width: 100%"
      :placeholder="$t('Find candidate')"
      @input="search"
      @blur.native="closeSearchEvent"
      @pressUp="optionUp"
      @pressDown="optionDown"
      @pressEnter="showCandidateModal(selected._id)" />

    <div
      v-if="focus"
      class="result-list">
      <div 
        class="list-group"
        v-if="loading">
        <div class="list-group-item">
          <creating height="20px" />
        </div>
      </div>
      <div
        v-if="!loading && candidates.length">
        <div class="list-group">
          <CandidateQuickSearchItem
            v-for="(candidate, index) in candidates"
            :key="index"
            :value="candidate"
            class="quicksearch-suggestion-item"
            :class="{ 'list-group-item-secondary': selected._id === candidate._id }"
            @showCandidate="showCandidateModal" />
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import InputKeyword from '@/components/Fields/InputKeyword'
import KeywordSearchSanitize from '@/utils/KeywordSearchSanitize'
import CandidateQuickSearchItem from './CandidateQuickSearchItem'

export default {
  name: 'Search',
  components: {
    InputKeyword,
    CandidateQuickSearchItem
  },
  data () {
    return {
      loading: false,
      candidates: [],
      keywords: '',
      focus: false,
      selected: {}
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    /*
    showCandidate
    */
    showCandidateModal (id) {
      this.$router.replace({ query: { candidate_id: id } })
      this.closeSearch()
    },
    /*
    clearSearch
    */
    closeSearchEvent (e) {
      console.log(e.relatedTarget)
      if (!(e.relatedTarget && e.relatedTarget.className.includes('quicksearch-suggestion-item'))) {
        this.closeSearch()
      }
    },
    closeSearch () {
      this.keywords = ''
      this.candidates = []
      this.focus = false
    },
    /*
    nav
    */
    navOptions (nav) {
      const borderOption = nav === 1 ? 0 : this.candidates.length - 1
      const curretnIndex = this.candidates.findIndex((val) => { return val._id === this.selected._id })
      const nextIndex = curretnIndex + nav
      this.selected = this.candidates[nextIndex] || this.candidates[borderOption]
    },
    optionUp () {
      this.navOptions(-1)
    },
    optionDown () {
      this.navOptions(1)
    },
    /*
    search
    */
    search (value) {
      if (!value) {
        this.loading = false
        this.candidates = []
        return false
      }

      this.loading = true
      this.focus = true

      this.$store
      .dispatch('getCandidates', {
        text: KeywordSearchSanitize(value),
        sort: '-score',
        limit: 5
      })
      .then((result) => {
        this.candidates = result.docs
        this.selected = this.candidates[0]
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*
search
*/
.search{
  position: relative;
  z-index: 2;
  min-width: 200px;
}
  .search .result-list{
    position: absolute;
    width: 100%;
    left: 0;
  }

/*
list-group
*/
.list-group > a{
  padding: 5px;
  display: flex;
  align-items: center;
}
  .list-group > a > .photo{
    min-width: 40px;
    min-height: 40px;
    flex: 0;
    margin-right: 5px;
  }
    .list-group > a > .photo img{
      width: 100%;
      border-radius: 5px;
    }
  .list-group > a > .name{
    flex: 1;
  }
/*
inputKeyword
*/
.inputKeyword{
  background: rgba(255,255,255,0.18);
  border: 0;
  color: #ffffff;
}
  .inputKeyword::placeholder {
    color: rgba(255,255,255,0.4);
  }
  .inputKeyword:-ms-input-placeholder {
    color: rgba(255,255,255,0.4);
  }
  .inputKeyword::-ms-input-placeholder {
    color: rgba(255,255,255,0.4);
}
</style>



// WEBPACK FOOTER //
// src/components/CandidateQuickSearch/CandidateQuickSearch.vue